export default __webpack_public_path__ + "static/media/raspberry-pi.9c49f271.png";